<template>
  <client-only>
    <div class="cn-tips-section">
      <div class="container">
        <TipsSectionTabs v-if="isDesktop" :tabs="data.items" />
        <TipsSectionAccordion v-else :tabs="data.items" />
      </div>
    </div>
  </client-only>
</template>

<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import TipsSectionTabs from '@/components/TipsSectionTabs';
import TipsSectionAccordion from '@/components/TipsSectionAccordion';

interface Props {
  data: {
    items: {
      title: string;
      text: string;
    }[];
  };
}
defineProps<Props>();

const breakpoints = useBreakpoints(breakpointsTailwind);
const isDesktop = breakpoints.greater('md');
</script>

<style lang="scss">
.cn-tips-section {
  --ab-canyon-tips-section-color-bg: var(--ab-canyon-color-neutral-light);

  background-color: var(--ab-canyon-tips-section-color-bg);
  padding-top: var(--size-3xl);
  padding-bottom: var(--size-3xl);
}
</style>
